/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Api_Errors_Too_Many_AttemptsInputs */

const nl_auth_api_errors_too_many_attempts = /** @type {(inputs: Auth_Api_Errors_Too_Many_AttemptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te veel pogingen. Probeer het over 15 minuten opnieuw.`)
};

/**

* @param {Auth_Api_Errors_Too_Many_AttemptsInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_api_errors_too_many_attempts = /** @type {((inputs?: Auth_Api_Errors_Too_Many_AttemptsInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Api_Errors_Too_Many_AttemptsInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_api_errors_too_many_attempts(inputs)
});
export { auth_api_errors_too_many_attempts as "auth.api_errors.too_many_attempts" }